import React from 'react';
import PropTypes from 'prop-types';
import { sortedAllDayEvents } from '~/Context/Event';
import DynamicEvent from '~/Containers/Pages/Calendar/WeekView/TimeGrid/DynamicEvent';

import './EventGroup.scss';

const EventGroup = ({ events, startAt, endAt }) => {
  if (!events) return null;
  let eventGroups = [];
  let currentGroup;
  const eventsCopy = sortedAllDayEvents([...events.filter(event => !event.isAllDay)]);

  eventsCopy.forEach(event => {
    if (
      currentGroup &&
      currentGroup.filter(groupEvent => {
        return (
          event.startInZone.isBefore(groupEvent.timeboxEnd) &&
          groupEvent.startInZone.isBefore(event.timeboxEnd)
        );
      })[0]
    ) {
      if (!currentGroup.filter(groupEvent => groupEvent.id === event.id)[0])
        currentGroup.push(event);
      return;
    }
    currentGroup = [event];
    eventGroups = [...eventGroups, currentGroup];
  });

  const columnsForGroup = eventGroup => {
    let eventColumns = [];
    eventGroup.forEach(event => {
      const addToColumn = eventColumns.filter(
        column =>
          !column.filter(columnEvent => {
            return (
              event.startInZone.isBefore(columnEvent.timeboxEnd) &&
              columnEvent.startInZone.isBefore(event.timeboxEnd)
            );
          })[0]
      )[0];
      if (addToColumn) {
        addToColumn.push(event);
      } else {
        eventColumns.push([event]);
      }
    });

    return eventColumns;
  };

  const renderEventGroup = (eventGroup, groupIndex) => {
    const [toRender, ...others] = columnsForGroup(eventGroup);
    const groupStartTime = eventGroup
      .map(event => (startAt.isBefore(event.startInZone) ? event.startInZone : startAt))
      .reduce((a, e) => (a.isBefore(e) ? a : e), startAt);
    const groupEndTime = eventGroup
      .map(event => (endAt.isAfter(event.timeboxEnd) ? event.timeboxEnd : endAt))
      .reduce((a, e) => (a.isAfter(e) ? a : e), endAt);

    const hourHeight = 39.0;
    const day = startAt.clone().startOf('day');

    const diffInMinutes = (a, b) => {
      if (!a.isSame(b, 'day'))
        console.warn('diffInMinutes should only be used with times on the same day');
      const aMinutes = a.hours() * 60 + a.minutes();
      const bMinutes = b.hours() * 60 + b.minutes();
      return bMinutes - aMinutes;
    };

    return (
      <div className="event-group-group" key={groupIndex}>
        <div className="event-group-events">
          {toRender.map((event, index) => {
            const eventStartsAt = event.startInZone.isBefore(startAt) ? startAt : event.startInZone;
            const eventEndsAt = event.timeboxEnd.isAfter(endAt) ? endAt : event.timeboxEnd;
            const top = hourHeight * (diffInMinutes(startAt, eventStartsAt) / 60);
            const height = hourHeight * (diffInMinutes(eventStartsAt, eventEndsAt) / 60);

            return (
              <DynamicEvent key={index} event={{ ...event }} top={top} height={height} day={day} />
            );
          })}
        </div>
        {!!others.length && (
          <div className="event-group-others" style={{ flexGrow: others.length }}>
            <EventGroup startAt={groupStartTime} endAt={groupEndTime} events={others.flat()} />
          </div>
        )}
      </div>
    );
  };

  return <div className="event-group-wrapper">{eventGroups.map(renderEventGroup)}</div>;
};

EventGroup.propTypes = {
  events: PropTypes.array.isRequired,
  startAt: PropTypes.object.isRequired,
  endAt: PropTypes.object.isRequired,
};

export default EventGroup;
